import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';

const Header = () => {


    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    const [menuOpen, setMenuOpen] = useState(false);


  return (
    <div className="topbar">
        <div className="logo">
          <img src="./assets/images/logo.png" />
        </div>
        
        <button 
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}>
          <i className="fas fa-bars"></i>
        </button>
        
        <div className={`nav-buttons ${menuOpen ? 'active' : ''}`}>
          <button onClick={() => handleNavigation('/')}>Home</button>
          <button onClick={() => handleNavigation('/servicos')}>Serviços</button>
          <button onClick={() => handleNavigation('/contato')}>Contato</button>
        </div>
      </div>
  );
};

export default Header;